import  Style from "components/UI/main.module.scss";
import { useState, useEffect } from 'react';

// This will manage the modal state globally
let showToastMessageCallback = null;
let hideToastMessageCallback = null;

export const useToastMessage = () => {
  return { showToastMessage: showToastMessageCallback, hideToastMessage: hideToastMessageCallback };
};

export const InfoToast = () => {
  const [displayToast,    setDisplayToast   ] = useState(false);
  const [messageBody,     setMessageBody    ] = useState({ header: '', message: '' });
  const [animationPhase,  setAnimationPhase ] = useState(''); // in | out

  // Show with animation
  showToastMessageCallback = ({ header, message }) => {
    setMessageBody({ header, message });
    setAnimationPhase('in');
    setDisplayToast(true);

    // Auto-hide
    setTimeout(() => {
      setAnimationPhase('out');
    }, 2500);
  };

  // Manual hide
  hideToastMessageCallback = () => setAnimationPhase('out');

  // Handle animation end
  const handleAnimationEnd = () => {
    if (animationPhase === 'out') {
      setDisplayToast(false);
    }
  };

  return (
    <>
      {displayToast && (
        <div
            className={[
              Style.toast_dialog,
              animationPhase === 'in'
                ? Style.toast_dialog_in
                : animationPhase === 'out'
                ? Style.toast_dialog_out
                : ''
            ].join(" ")}
            onAnimationEnd={handleAnimationEnd}
            onClick={() => {setAnimationPhase('out');}}
        >
          <div className={[Style.toast_content, Style.rounded_3, Style.shadow, Style.border, Style.background_bg].join(" ")}>
            <div className={[Style.m_3, Style.px_3].join(" ")}>
              <div className={Style.toast_header}>
                <span className={[Style.my_2, Style.text_body, Style.fs_6, Style.fw_semibold].join(" ")}>
                  {messageBody.header}
                </span>
              </div>
              <div className={[Style.toast_body, Style.mb_3].join(" ")}>
                <span className={[Style.text_body, Style.fs_8].join(" ")}>
                  {messageBody.message}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

